import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Mail, ArrowLeft, Sun, Moon, CheckCircle } from 'lucide-react';
import { MetaTradifyLogo } from '@/components/MetaTradifyLogo';
import { toast } from 'sonner';
import axios from 'axios';
import AdminLayout from '@/components/AdminLayout';
import { adminAPI } from '@/lib/api';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
export default function AdminSendEmailsPage() {
  const { theme, toggleTheme } = useTheme();
console.log(ReactQuill,"re");

  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !subject || !message) {
      toast.error('All fields are required');
      return;
    }

    setLoading(true);

    try {
      await adminAPI.sendEmail({ to_email: email, subject, message });

setEmail('');
setSubject('');
setMessage('');
      toast.success('Email sent successfully');
    } catch (err) {
      toast.error('Failed to send email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="min-s-screen bg-[var(--bg-primary)] flex items-center justify-center px-2">


        {/* Background Glow */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-green-500/5 rounded-full blur-[100px]" />
        </div>

        <div className="w-full max-w-[400px] relative">

          {/* Header */}
          <div className="text-center mb-8">

            <h1 className="text-2xl font-bold text-[var(--text-primary)]">
              Send Email
            </h1>

            <p className="text-sm text-[var(--text-secondary)] mt-1">
              Send manual email to any user
            </p>
          </div>


          <form onSubmit={handleSubmit} className="space-y-4">

            {/* Email */}
            <div className="space-y-2">
              <Label className="text-sm text-[var(--text-secondary)]">
                Email
              </Label>

              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-tertiary)]" />

                <Input
                  type="email"
                  placeholder="user@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-[var(--bg-surface)] border-[var(--border-subtle)] text-[var(--text-primary)] h-11 pl-10"
                />
              </div>
            </div>

            {/* Subject */}
            <div className="space-y-2">
              <Label className="text-sm text-[var(--text-secondary)]">
                Subject
              </Label>

              <Input
                type="text"
                placeholder="Enter subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="bg-[var(--bg-surface)] border-[var(--border-subtle)] text-[var(--text-primary)] h-11"
              />
            </div>

            {/* Message */}
            <div className="space-y-2">
  <Label className="text-sm text-[var(--text-secondary)]">
    Message
  </Label>

  <ReactQuill
  value={message}
  onChange={setMessage}
  theme="snow"
  placeholder="Type your message here..."
  className="quill-custom"
/>
</div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="w-full h-11 bg-green-500 hover:bg-green-600 text-white rounded text-sm font-medium transition-all disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send Email'}
            </button>

          </form>





        </div>
      </div>
    </AdminLayout>
  );

}